/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  modals: {
    [key: string]: boolean; // Boolean flag for modal visibility
  };
  props: {
    [key: string]: any; // Props specific to each modal
  };
  isOpen: boolean;
}

const initialState: ModalState = {
  modals: {
    ModalSearchChat: false,
    ModalDeleteChat: false,
    ModalRenameChat: false,
    ModalFedback: false,
    ModalCreateFolder: false,
    ModalGiveFeedback: false,
    ModalShareLink: false,
  },
  props: {}, // Default props are empty
  isOpen: false, // Separate modal flag
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ name: keyof ModalState["modals"]; props?: any }>
    ) => {
      Object.keys(state.modals).forEach((key) => {
        state.modals[key] = false; // Close all other modals
      });
      state.modals[action.payload.name] = true; // Open the specific modal
      state.props = action.payload.props || {}; // Set props safely
    },
    closeModal: (state, action: PayloadAction<keyof ModalState["modals"]>) => {
      state.modals[action.payload] = false; // Close the modal
      state.props = {}; // Clear props
    },
    toggleModal: (state) => {
      state.isOpen = !state.isOpen;
    },
    closeAllModals: (state) => {
      Object.keys(state.modals).forEach((key) => {
        state.modals[key] = false; // Close all modals
      });
      state.props = {}; // Clear props
    },
  },
});

export const { openModal, closeModal, toggleModal,closeAllModals } = modalSlice.actions;
export default modalSlice.reducer;
